import React, { useEffect, useState } from "react";
import watermark from "../assets/img/form/watermark1.webp";
import { useLoader } from "../context/LoaderContext";
import RefactoredApplicationForm from "../components/application/RefactoredApplicationForm";
import { dynamicFailed } from "../hooks/custom/useToast";
import {
  fetchAdmissionPolicy,
  fetchScholarshipsAndFinancial,
} from "../api/UndergraduateProgramsApi";
import {
  IAdmissionPolicyData,
  IScholarshipsAndFinancialData,
} from "../exports/interfaces";

const ApplicationPage = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    setLoading(true);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [setLoading]);

  const [admissionPolicy, setAdmissionPolicy] = useState<
    IAdmissionPolicyData[]
  >([]);
  const [scholarshipsAndFinancial, setScholarshipsAndFinancial] = useState<
    IScholarshipsAndFinancialData[]
  >([]);

  useEffect(() => { 
    setLoading(true);
    Promise.all([fetchAdmissionPolicy(), fetchScholarshipsAndFinancial()])
      .then(([admissionPolicyData, scholarshipsAndFinancialData]) => {
        setAdmissionPolicy(admissionPolicyData);
        setScholarshipsAndFinancial(scholarshipsAndFinancialData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <div className="form-wrapper">
        <img src={watermark} alt="watermark" className="watermark" />
        {/* <FormBanner /> */}
        {/* <ApplicationForm /> */}
        <div className="td_mb_60" />
        <RefactoredApplicationForm admissionPolicy={admissionPolicy} scholarshipsAndFinancial={scholarshipsAndFinancial}/>
      </div>
    </>
  );
};

export default ApplicationPage;
